module.exports = __webpack_public_path__ + "static/saltaire-hero.fa913121.jpg";